import { z } from "zod";

/**
 * Per-user Ask Puntt email notification opt-in/out.
 * Mentions and action-needed emails default on; other toggles default off.
 */
export const askPunttNotificationPrefsSchema = z.object({
  emailMention: z.boolean().default(true),
  emailNewMessage: z.boolean().default(false),
  emailReviewComplete: z.boolean().default(false),
  emailArtifactReady: z.boolean().default(false),
  emailProjectActivity: z.boolean().default(false),
  emailActionNeeded: z.boolean().default(true),
});

export type AskPunttNotificationPrefs = z.infer<
  typeof askPunttNotificationPrefsSchema
>;

/**
 * The STORED shape: the same six keys, with the defaults stripped.
 *
 * A stored document is a record of what the person actually did. A key that is
 * present is a choice she made; a key that is absent is one she was never
 * asked about. `askPunttNotificationPrefsSchema` erases that distinction — it
 * fills every absent key with its default — so a profile response parsed
 * through it reports a default-`false` toggle and a never-asked toggle
 * identically, and anything that echoes the parsed object back (the
 * notifications page's PUT) turns the default into a stored choice.
 *
 * Keep the key list in step with `askPunttNotificationPrefsSchema`; this is
 * `.partial()` of it, not a second definition, so it cannot drift.
 */
export const storedAskPunttNotificationPrefsSchema =
  askPunttNotificationPrefsSchema.partial();

export type StoredAskPunttNotificationPrefs = z.infer<
  typeof storedAskPunttNotificationPrefsSchema
>;

export const defaultAskPunttNotificationPrefs: AskPunttNotificationPrefs =
  askPunttNotificationPrefsSchema.parse({});
